import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {AdyenShippingMethodsService} from '../services/shipping-methods'
import {ShopperBasketService} from '../services/basket'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {getAdyenPaymentMethods} from '../utils/get-adyen-payment-methods'
import {fetchShippingMethods} from '../utils/orderUtils'
import {getAdyenShippingMethods} from '../utils/get-adyen-shipping-methods'

export const AdyenExpressCheckoutContext = React.createContext({})

export const updateBasket = async (basketId, site, authToken) => {
    const shopperBasketService = new ShopperBasketService(authToken, site)
    try {
        return await shopperBasketService.updateBasket(basketId, {
            c_isCart: true
        })
    } catch (error) {
        return null
    }
}

export const AdyenExpressCheckoutProvider = ({
    children,
    authToken,
    customerId,
    locale,
    site,
    basket,
    navigate,
    isMiniCart
}) => {
    const [adyenPaymentMethods, setAdyenPaymentMethods] = useState()
    const [adyenEnvironment, setAdyenEnvironment] = useState()
    const [shippingMethods, setShippingMethods] = useState()
    const {app: appConfig} = getConfig()

    useEffect(() => {
        const fetchAdyenData = async () => {
            const [paymentMethods] = await Promise.all([
                getAdyenPaymentMethods(customerId, authToken, locale, site)
            ])
            setAdyenEnvironment(
                {
                    ADYEN_ENVIRONMENT: appConfig.adyen.environment,
                    ADYEN_CLIENT_KEY: appConfig.adyen.clientKey
                } || {error: true}
            )
            setAdyenPaymentMethods(paymentMethods || {error: true})
        }
        fetchAdyenData()
    }, [])

    useEffect(() => {
        const fetchShippingMethodsData = async () => {
            const data = await getAdyenShippingMethods(basket?.basketId, authToken, site, locale)
            setShippingMethods(data || {error: true})
        }

        if (basket?.basketId) {
            fetchShippingMethodsData()
        }
    }, [basket?.basketId, site, authToken])

    useEffect(() => {
        if (isMiniCart) {
            updateBasket(basket?.basketId, site, authToken)
        }
    }, [isMiniCart])

    const value = {
        adyenEnvironment,
        adyenPaymentMethods,
        basket,
        locale,
        site,
        authToken,
        navigate,
        shippingMethods,
        fetchShippingMethods,
        isMiniCart
    }

    return (
        <AdyenExpressCheckoutContext.Provider value={value}>
            {children}
        </AdyenExpressCheckoutContext.Provider>
    )
}

AdyenExpressCheckoutProvider.propTypes = {
    children: PropTypes.any,
    authToken: PropTypes.any,
    customerId: PropTypes.any,
    locale: PropTypes.any,
    site: PropTypes.any,
    basket: PropTypes.any,
    navigate: PropTypes.any,
    isMiniCart: PropTypes.any
}

export default AdyenExpressCheckoutProvider
